import React from 'react';

import {observer} from "mobx-react";
import {H2hWidgetAsync} from "../../../h2h-widget/components/h2h-widget.async";
import {ENTITY_TYPES} from "../../../../core/app/consts";
import styles from "../../styles/game-center-widget.module.scss";
import classNames from "classnames";
import {OddsByWidgetAsync} from "../../../odds-by-widget/components/odds-by-widget.async";

export const GameCenterWidgetContentH2hTab = observer(({controller, matchupId, gameId, location, showOdds}) => {
  const {state} = controller;
  const {shouldRenderH2h, device: {isSmallView}} = state;

  const h2hProps = {
    matchupId,
    gameId,
    location,
    showOdds,
    isFullView: true,
  }

  const oddsByWidgetProps = {
    entityId: gameId,
    entityType: ENTITY_TYPES.game,
    className: classNames(styles.odds_by, {[styles.small_view]: isSmallView})
  }

  return (shouldRenderH2h ? <>
    <OddsByWidgetAsync {...oddsByWidgetProps} />
    <H2hWidgetAsync {...h2hProps}/>
  </> : null)
});
